export default "__VITE_ASSET__CY8U_Tt9__"